const singlePostIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/SVG"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1098 5.63415H5.89024C5.74881 5.63415 5.63415 5.74881 5.63415 5.89024V7.93902C5.63415 8.08046 5.74881 8.19512 5.89024 8.19512H15.1098C15.2512 8.19512 15.3659 8.08046 15.3659 7.93902V5.89024C15.3659 5.7488 15.2512 5.63415 15.1098 5.63415ZM5.89024 4.09756C4.90017 4.09756 4.09756 4.90017 4.09756 5.89024V7.93902C4.09756 8.9291 4.90017 9.73171 5.89024 9.73171H15.1098C16.0998 9.73171 16.9024 8.9291 16.9024 7.93902V5.89024C16.9024 4.90017 16.0998 4.09756 15.1098 4.09756H5.89024Z"
      fill="#6B00DF"
    />
    <path
      d="M4.09756 12.6768C4.09756 12.1818 4.49887 11.7805 4.9939 11.7805H16.0061C16.5011 11.7805 16.9024 12.1818 16.9024 12.6768C16.9024 13.1719 16.5011 13.5732 16.0061 13.5732H4.9939C4.49887 13.5732 4.09756 13.1719 4.09756 12.6768Z"
      fill="#6B00DF"
    />
    <path
      d="M4.09756 16.2622C4.09756 15.7672 4.49887 15.3659 4.9939 15.3659H16.0061C16.5011 15.3659 16.9024 15.7672 16.9024 16.2622C16.9024 16.7572 16.5011 17.1585 16.0061 17.1585H4.9939C4.49887 17.1585 4.09756 16.7572 4.09756 16.2622Z"
      fill="#6B00DF"
    />
  </svg>
);

export default singlePostIcon;

const nativeBlockIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/SVG"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1098 5.63415H5.89024C5.74881 5.63415 5.63415 5.74881 5.63415 5.89024V7.93902C5.63415 8.08046 5.74881 8.19512 5.89024 8.19512H15.1098C15.2512 8.19512 15.3659 8.08046 15.3659 7.93902V5.89024C15.3659 5.7488 15.2512 5.63415 15.1098 5.63415ZM5.89024 4.09756C4.90017 4.09756 4.09756 4.90017 4.09756 5.89024V7.93902C4.09756 8.9291 4.90017 9.73171 5.89024 9.73171H15.1098C16.0998 9.73171 16.9024 8.9291 16.9024 7.93902V5.89024C16.9024 4.90017 16.0998 4.09756 15.1098 4.09756H5.89024Z"
      fill="#6B00DF"
    />
    <path
      d="M4.09756 12.6768C4.09756 12.1818 4.49887 11.7805 4.9939 11.7805H16.0061C16.5011 11.7805 16.9024 12.1818 16.9024 12.6768C16.9024 13.1719 16.5011 13.5732 16.0061 13.5732H4.9939C4.49887 13.5732 4.09756 13.1719 4.09756 12.6768Z"
      fill="#6B00DF"
    />
    <path
      d="M4.09756 16.2622C4.09756 15.7672 4.49887 15.3659 4.9939 15.3659H16.0061C16.5011 15.3659 16.9024 15.7672 16.9024 16.2622C16.9024 16.7572 16.5011 17.1585 16.0061 17.1585H4.9939C4.49887 17.1585 4.09756 16.7572 4.09756 16.2622Z"
      fill="#6B00DF"
    />
  </svg>
);

const customBlockIcon = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_115_13)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5609 3.51221H6.43902C4.82258 3.51221 3.51221 4.82258 3.51221 6.43902V41.5609C3.51221 43.1774 4.82258 44.4878 6.43902 44.4878H41.5609C43.1774 44.4878 44.4878 43.1774 44.4878 41.5609V6.43902C44.4878 4.82258 43.1774 3.51221 41.5609 3.51221ZM6.43902 0C2.88286 0 0 2.88286 0 6.43902V41.5609C0 45.1173 2.88286 48 6.43902 48H41.5609C45.1173 48 48 45.1173 48 41.5609V6.43902C48 2.88286 45.1173 0 41.5609 0H6.43902Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.5367 12.8781H13.4634C13.1401 12.8781 12.8781 13.1401 12.8781 13.4634V18.1463C12.8781 18.4696 13.1401 18.7317 13.4634 18.7317H34.5367C34.8599 18.7317 35.1221 18.4696 35.1221 18.1463V13.4634C35.1221 13.1401 34.8599 12.8781 34.5367 12.8781ZM13.4634 9.36584C11.2004 9.36584 9.36584 11.2004 9.36584 13.4634V18.1463C9.36584 20.4094 11.2004 22.2439 13.4634 22.2439H34.5367C36.7995 22.2439 38.634 20.4094 38.634 18.1463V13.4634C38.634 11.2004 36.7995 9.36584 34.5367 9.36584H13.4634Z"
        fill="#6B00DF"
      />
      <path
        d="M9.36584 28.9756C9.36584 27.8441 10.2831 26.9269 11.4146 26.9269H36.5854C37.7168 26.9269 38.634 27.8441 38.634 28.9756C38.634 30.1072 37.7168 31.0245 36.5854 31.0245H11.4146C10.2831 31.0245 9.36584 30.1072 9.36584 28.9756Z"
        fill="#9B9B9B"
      />
      <path
        d="M9.36584 37.1708C9.36584 36.0393 10.2831 35.1221 11.4146 35.1221H36.5854C37.7168 35.1221 38.634 36.0393 38.634 37.1708C38.634 38.3022 37.7168 39.2194 36.5854 39.2194H11.4146C10.2831 39.2194 9.36584 38.3022 9.36584 37.1708Z"
        fill="#6B00DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_115_13">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { customBlockIcon, nativeBlockIcon };
